import { render } from "./Page-Resine.vue?vue&type=template&id=0e186cc2&scoped=true"
import script from "./Page-Resine.vue?vue&type=script&lang=js"
export * from "./Page-Resine.vue?vue&type=script&lang=js"

import "./Page-Resine.vue?vue&type=style&index=0&id=0e186cc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e186cc2"]])

export default __exports__